Vendd.Scripts.load(function () {
    var $wrapper = $('.gallery-look-container');

    initCarousel();
    initFancybox();

    function initCarousel() {
        var $mainGallery = $('> ul', $wrapper);

        if ($mainGallery.length < 1)
            return;

        var carouselMainOpts = {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            adaptiveHeight: true,
            draggable: false,
            prevArrow: $('.nav-prev', $wrapper),
            nextArrow: $('.nav-next', $wrapper),
            dots: true
        };

        $mainGallery.slick(carouselMainOpts);
    };

    function initFancybox() {

        var $fancyLinks = $('.look-fancybox-gallery', $wrapper);


        if ($fancyLinks.length < 1)
            return;

        var fbOpts = {
            protect: true,
            infobar: true
        };

        $fancyLinks.fancybox(fbOpts);

        $('.fancy-btn', $wrapper).on('click', function (e) {
            var $slideWrapper = $('.slick-initialized', $wrapper);
            if ($slideWrapper.length > 0) {
                $('.slick-active', $slideWrapper).find('.look-fancybox-gallery').trigger('click');
            }

        });
    };
});
